import { IssueData, ZodIssueCode } from 'zod';
import { isUndefined } from 'utils/tsHelpers';
import { AnyComparator, CastType, DefaultComparator } from '../../../types';

export const validateNonCastTypeNumberValue = (
  {
    value,
    values,
    comparatorType,
    castType,
  }: Partial<{
    value: string;
    values: string[];
    comparatorType: AnyComparator;
    castType: CastType;
  }>,
  addIssue: (arg: IssueData) => void,
) => {
  const doesNotHaveValues = isUndefined(values);
  const isNotANumberValue = !!isNaN(Number(value));
  const isNotIsSetComparator =
    comparatorType !== DefaultComparator.IS_SET && comparatorType !== DefaultComparator.IS_NOT_SET;
  const hasNoCastType = isUndefined(castType);

  const hasNonCastTypeNumberValueError =
    doesNotHaveValues && isNotANumberValue && isNotIsSetComparator && hasNoCastType;

  if (hasNonCastTypeNumberValueError) {
    addIssue({
      code: ZodIssueCode.custom,
      message: 'invalid number value',
      path: ['value'],
    });
  }
};
